import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient único e global da aplicação.
 *
 * Mora aqui, e não em `App.js`, por um motivo prático: `App.js` importa o
 * `Router` inteiro (e com ele MUI, mapbox, quill, `mui-tel-input`), então
 * qualquer teste que precise do client teria de carregar meia aplicação — e
 * hoje nem carrega, porque `mui-tel-input` é ESM puro e o Jest deste projeto
 * não tem `transformIgnorePatterns`. Num módulo isolado, o client é testável
 * sem mock e sem arrastar a árvore de componentes.
 *
 * `App.js` reexporta `queryClient` para não quebrar quem já importa de `@/App`
 * (ex.: `src/contexts/SubscriptionContext.js`).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      /**
       * `onError` padrão para toda mutation: sem ele, uma mutation que não
       * declara o próprio `onError` falha em silêncio — a API devolve 4xx/5xx
       * e a UI não dá sinal nenhum. Foi o caso do cancelamento de assinatura
       * no portal do assinante.
       *
       * Rede de segurança, não substituto: quem precisa de mensagem específica
       * continua declarando `onError` no próprio `useMutation`, e este default
       * deixa de ser chamado para aquela mutation. Não mostra UI de propósito —
       * este módulo vive fora da árvore React e não alcança `useNotify`; o
       * texto útil é responsabilidade de quem conhece o contexto.
       */
      onError: (error) => {
        // eslint-disable-next-line no-console
        console.error('[mutation] falha nao tratada', error);
      },
    },
  },
});

export default queryClient;
